import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CustomButton from 'components/CustomInput/Button';
import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import { useHistory } from 'react-router';
import api from 'api/call';
import { setGlobalLoading } from 'store/global/reducer';
import {
    MISCELLANEOUS_REPORT,
    PROGRESS_REPORT,
    PROTOCOL_DEVIATION_REPORT,
    LOCAL_SAE_REPORT,
    FINAL_REPORT,
} from 'utility/postApprovalLookUp';

const ProgressReportSelectModal = ({
    isShow = false,
    onCancel = () => null,
    row,
    listOfSite = [],
    appId,
    title,
    bothStudyAndSiteBase,
    docType,
}) => {
    const [site, setSite] = useState('');
    const [forceErrorDisplay, setForceErrorDisplay] = useState(false);
    const [isValid, setValid] = useState(false);
    const history = useHistory();

    const paths = {
        [MISCELLANEOUS_REPORT]: '/miscellaneous-report?appId=',
        [PROGRESS_REPORT]: '/progress-report?appId=',
        [PROTOCOL_DEVIATION_REPORT]: '/protocol-deviation?appId=',
        [LOCAL_SAE_REPORT]: '/SAE-report?appId=',
    };

    // stage includes select, exist
    const [stage, setStage] = useState('select');

    const [existFormId, setExistFormId] = useState(0);

    const getTitle = () => {
        if (stage === 'select') {
            return `Please select the site for creating ${title}`;
        } else if (stage === 'exist') {
            return `Existing ${title} is found`;
        }
    };

    const getContent = () => {
        if (stage === 'select') {
            return (
                <CustomOutlineSelect
                    value={site}
                    onChange={(e) => {
                        const { value } = e.target;
                        setSite(value);
                    }}
                    label={'Choose one'}
                    choices={listOfSite.map((item) => {
                        return {
                            key: item.id,
                            display: item.display,
                        };
                    })}
                    placeholder={'Please choose your site'}
                    isRequired
                    forceErrorDisplay={forceErrorDisplay}
                    isValidValue={(isValid) => setValid(isValid)}
                />
            );
        } else if (stage === 'exist') {
            return `Do you want to redirect to the existing ${title}?`;
        } else {
            return 'test';
        }
    };

    const checkIsProgressReportExist = () => {
        // approval/check-exist-progress-report?siteId=19
        api.postApprovalActivities
            .checkExistProgressReport(row.id, site)
            .then(async (res) => {
                const { reportId } = res.data.result;

                if (reportId) {
                    setStage('exist');
                    setExistFormId(reportId);
                } else {
                    history.push(`/progress-report?appId=${row.id}&siteId=${site}`);
                }
            })
            .finally(() => {
                setGlobalLoading(false);
            });
    };

    const checkIsFinalReportExist = () => {};

    const handleOk = () => {
        if (!isValid) {
            return setForceErrorDisplay(true);
        }

        setGlobalLoading(true);

        if (docType === PROGRESS_REPORT) {
            checkIsProgressReportExist();
        } else if (docType === FINAL_REPORT) {
            checkIsFinalReportExist();
        } else {
            let siteQuery = `&siteId=${site}`;

            // if the selection is study info, remove the site id query to server
            if (site === 'studyInfo') {
                siteQuery = '';
            }

            setGlobalLoading(false);
            return history.push(`${paths[docType]}${row.id}${siteQuery}`);
        }
    };

    return (
        <Dialog open={isShow} style={{ margin: 'auto' }}>
            <DialogTitle style={{ fontWeight: 'bold', width: 400 }}>
                <div style={{ fontSize: 16 }}>{getTitle()}</div>
            </DialogTitle>
            <DialogContent>{getContent()}</DialogContent>
            <DialogActions style={{ padding: 15 }}>
                <CustomButton type={'cancel'} onClick={onCancel} autoFocus>
                    Cancel
                </CustomButton>
                <CustomButton
                    onClick={() => {
                        if (stage === 'exist') {
                            if (docType === PROGRESS_REPORT) {
                                history.push(`/progress-report?reportId=${existFormId}`);
                            } else if (docType === FINAL_REPORT) {
                                history.push(`/final-report?reportId=${existFormId}`);
                            }
                        } else if (stage === 'select') {
                            handleOk();
                        }
                    }}
                    autoFocus
                >
                    Confirm
                </CustomButton>
            </DialogActions>
        </Dialog>
    );
};

export default ProgressReportSelectModal;
